export type InspectionPhotoRotation = "portrait" | "landscape";
export class InspectionPhoto {
  constructor(
    public readonly id: string,
    public readonly inspectionId: string,
    public readonly url: string,
    public readonly description: string,
    public readonly rotation: number,
    public readonly order: number,
    public readonly baseRotation: InspectionPhotoRotation | null,
    public readonly questionId: string | null,
  ) {}

  static fromJson(json: any): InspectionPhoto {
    return new InspectionPhoto(
      json["id"],
      json["inspection_id"],
      json["url"],
      json["description"],
      json["rotation"],
      json["order"],
      json["base_rotation"] ?? null,
      json["question_id"] ?? null,
    );
  }
}
